import { FaChevronLeft } from "react-icons/fa";
import { useRecoilState } from "recoil";
import { selectionAtom } from "../store/selection.atom";
import { visibilityAtom } from "../store/visibility";

const CategoryTitle = () => {
  const [{ category, blog }, setSelection] = useRecoilState(selectionAtom);
  const [, setVisibility] = useRecoilState(visibilityAtom);

  return (
    <div className="flex items-center gap-2 border-b-[1px] border-b-rss-border p-5 font-bold text-rss-primary-color">
      <FaChevronLeft
        onClick={() => {
          if (blog) {
            setSelection((prev) => ({
              ...prev,
              blog: undefined,
            }));
            setVisibility((prev) => ({
              ...prev,
              showTitles: true,
            }));
          } else {
            setSelection((prev) => ({ ...prev, category: undefined }));
          }
        }}
        className="cursor-pointer"
      />
      {category?.title}
    </div>
  );
};

export default CategoryTitle;
